import { GrafferPermissions } from "./rbac";

/**
 * Permissionの一覧を表す
 */
export class PermissionSet {
  public readonly set: Set<GrafferPermissions>;

  constructor(list: readonly GrafferPermissions[]) {
    this.set = new Set<GrafferPermissions>(list);
  }

  intersection(set: GrafferPermissions[]) {
    const _intersection: GrafferPermissions[] = [];
    set.forEach((elem) => {
      if (this.set.has(elem)) {
        _intersection.push(elem);
      }
    });
    return new PermissionSet(_intersection);
  }

  containsAll(perms: GrafferPermissions[]) {
    return !perms.find((p) => !this.set.has(p));
  }
}
